query UnpaidContractPayments {
  waitPayment: contractPayments(
    filter: { status: "wait_payment" }
    rowsPerPage: 50
  ) {
    count
    nodes {
      id
      periodFrom
      periodTo
      invoiceDate
      expiredAt
      paidAt
      status
      expired
      amount {
        value
        currency
      }
      invoiceAmount {
        value
        currency
      }
      invoice {
        number
        issuedAt
      }
      invoiceUrl
      createdAt
    }
  }
  onWay: contractPayments(filter: { status: "on_way" }, rowsPerPage: 50) {
    count
    nodes {
      id
      periodFrom
      periodTo
      invoiceDate
      expiredAt
      paidAt
      status
      expired
      amount {
        value
        currency
      }
      invoiceAmount {
        value
        currency
      }
      invoice {
        number
        issuedAt
      }
      invoiceUrl
      createdAt
    }
  }
}
